module.exports = __webpack_public_path__ + "static/media/Lesson-5-7-The-Healing-Power-of-the-Tongue.bf3d3f5b.pdf";